var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 250,
    viewBox: "0 0 200 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V250H0V0Z",
    fill: "url(#paint0_linear_1_45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8667 15H61.08V22.1267H67.68V15H74.8933V36.5733H67.68V29.3533H61.08V36.5733H53.8733V15H53.8667ZM84.3733 22.1533H78.0267V15H97.94V22.1533H91.5867V36.5733H84.3733V22.1533V22.1533ZM101.1 15H108.62L113.247 22.58L117.867 15H125.387V36.5733H118.207V25.88L113.247 33.5533H113.12L108.153 25.8867V36.5733H101.1V15V15ZM128.973 15H136.193V29.4467H146.327V36.58H128.973V15V15Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.64 162.147L40 46.4467H160L146.353 162.133L99.9333 175L53.64 162.147ZM81.22 98.8133L79.9267 84.28H134.227L135.493 70.0933H64.4267L68.2533 113.007H117.433L115.787 131.407L99.96 135.687H99.9467L84.1467 131.42L83.1333 120.107H68.88L70.8667 142.387L99.9333 150.453L129.047 142.387L132.593 102.627L132.94 98.82H81.22V98.8133Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_45",
    x1: 0,
    y1: 0,
    x2: 243.902,
    y2: 195.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6416C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlLogo);
export default __webpack_public_path__ + "static/media/HtmlLogo.d1435a9bcd5318bb3dd905e593f596b4.svg";
export { ForwardRef as ReactComponent };